import React, { useEffect } from 'react';
import classnames from 'classnames';

import styles from './Search.module.scss';

import injectScript from '../../injectScript';

import './addsearch.scss';
import { Icon, Element } from '@gaiads/telia-react-component-library';

export type SearchProps = {
  /** Search page url. Goes there if user hits enter after keyword */
  searchPageUrl: string;
  /** Url for AddSearch script */
  addSearchScriptUrl: string;
  /** Key for AddSearch script (Not needed if included in the AddSearch script url) */
  addSearchScriptKey?: string;
  /** Placeholder text for search input field */
  placeholder: string;
  /** Is search visible */
  isOpen: boolean;
  /** Toggle search callback */
  onSearchToggle: () => void;
};

const Search: React.FunctionComponent<SearchProps> = ({
  placeholder,
  searchPageUrl,
  addSearchScriptUrl,
  addSearchScriptKey = '',
  isOpen,
  onSearchToggle,
}: SearchProps) => {
  const textInput = React.createRef<HTMLInputElement>();

  // AddSearch script injection. Search will not work without it.
  injectScript(`${addSearchScriptUrl}${addSearchScriptKey}`);

  useEffect(() => {
    if (isOpen) {
      textInput.current?.focus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  return (
    <div className={styles.search}>
      <form action={searchPageUrl} method="GET" className={styles.search_form}>
        <div
          data-testid="search-overlay"
          onClick={() => onSearchToggle()}
          className={classnames({
            [styles.search_overlay]: true,
            [styles.search_overlay__visible]: isOpen,
          })}
        />

        <div
          data-testid="search"
          className={classnames({
            [styles.search_inputWrapper]: true,
            [styles.search_inputWrapper__active]: isOpen,
          })}
        >
          <Element
            tagName="button"
            data-testid="search-open-icon"
            className={styles.search_icon}
            onClick={(event: React.MouseEvent) => {
              if (!isOpen) {
                event.preventDefault();
              }
              onSearchToggle();
            }}
            tabIndex={0}
          >
            <Icon name="search" size="lg" color="black" />
          </Element>

          <input
            data-addsearch-field
            disabled
            ref={textInput}
            autoComplete="off"
            className={classnames(styles.search_input, 'addsearch')}
            type="text"
            placeholder={placeholder}
            tabIndex={isOpen ? 0 : -1}
          />

          <Element
            tagName="button"
            data-testid="search-close-icon"
            className={styles.search_closeIcon}
            onClick={(event: React.MouseEvent) => {
              event.preventDefault();
              onSearchToggle();
            }}
            tabIndex={isOpen ? 0 : -1}
          >
            <Icon name="close" size="lg" color="black" />
          </Element>
        </div>
      </form>
    </div>
  );
};

export default Search;
